import { Field } from "formik";
import VStack from "../layout/VStack/VStack";

const FormattedNumberInput = ({
  label,
  name,
  placeholder,
  errorMessage,
  required,
  type = "text",
  disabled = false,
  isFormik = true,
  value,
  onChange,
  maxLength,
  gap = 4,
}) => {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    const rawValue = inputValue.replace(/[^\d]/g, "");

    if (onChange) {
      onChange(rawValue ? parseInt(rawValue, 10) : "");
    }
  };

  const displayValue =
    typeof value === "number" ? value.toLocaleString() : value || "";

  return (
    <VStack gap={gap}>
      <label className="tText text-sm">
        {label}
        <span style={{ color: required ? "red" : "black" }}>
          {required ? "*" : ""}
        </span>
      </label>
      {isFormik ? (
        <Field
          type={type}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          value={displayValue}
          onChange={handleChange}
        />
      ) : (
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
        />
      )}
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </VStack>
  );
};

export default FormattedNumberInput;
